<div class="container greyTextContainer">
  <h1>Complaint Sent!</h1>
  <br />

  <p>
    You complaint has been sent to ADIEM with your complaint. We take complaints very
    seriously and will be in touch with you shortly.
  </p>

  <button class="okBtn" mat-button mat-raised-button color="accent" type="button" (click)="back()">
    Ok
  </button>
</div>